import { render } from "./UpdatedProperties.vue?vue&type=template&id=4fd328e2"
import script from "./UpdatedProperties.vue?vue&type=script&lang=js"
export * from "./UpdatedProperties.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__